
import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";

const useRates = (coinName?: string) => {
  const axiosInstance = useAuthAxios();

  const getRate = async () => {
    const response = await axiosInstance.get(API.getRates);
    return response.data.data.rates;
  };

  const { data: rates, isLoading, error } = useQuery({
    queryKey: ["get-rates"],
    queryFn: getRate,
    retry: 1,
    enabled: !!coinName,
  });

  const coinRate = rates?.find(
    (rate: { abbr: string }) =>
      rate.abbr?.toLowerCase() === coinName?.toLowerCase()
  );

  return { rate: coinRate?.rate, isLoading, error };
};

export default useRates;
